import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Projects from "@/components/Projects";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#F2F2F0] text-[#111111] antialiased">
      <Toaster position="bottom-right" richColors />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <Contact />
        <Projects />
      </main>
      <Footer />
    </div>
  );
}

export default App;
